import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { RevisionSavePlanAssignmentsPayload } from 'api/actions/revision-save-plan-assignments/revision-save-plan-assignments-payload';
import { RevisionSavePlanAssignmentsPathParameters } from 'api/actions/revision-save-plan-assignments/revision-save-plan-assignments-path-parameters';
import { RevisionSavePlanAssignmentsResponse } from 'api/actions/revision-save-plan-assignments/revision-save-plan-assignments-response';

type RevisionSavePlanAssignmentsQueryParameters = Record<string, any>;

/**
 * The path of the RevisionSavePlanAssignments action.
 */
export const revisionSavePlanAssignmentsActionPath = new SweetPath<keyof RevisionSavePlanAssignmentsPathParameters>(
  '/api/revision/plan-assignments/{revisionId}',
  { path: '{param}' }
);

/**
 * Creates a contextualized RevisionSavePlanAssignments actions.
 */
export default function createRevisionSavePlanAssignmentsAction(axios: AxiosInstance) {
  return function revisionSavePlanAssignmentsAction({
    headers = {},
    parameters,
    query = {},
    payload,
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: RevisionSavePlanAssignmentsPathParameters;
    query?: RevisionSavePlanAssignmentsQueryParameters;
    payload: RevisionSavePlanAssignmentsPayload;
  }) {
    const path = revisionSavePlanAssignmentsActionPath.insert(parameters);

    return axios.request<RevisionSavePlanAssignmentsResponse, RevisionSavePlanAssignmentsResponse>({
      method: 'put',
      url: path,
      params: query,
      data: payload,
      headers,
    });
  };
}
